// © 2015-2021 WDNA - All Rights Reserved

import api, { AxiosRequestConfig } from '../../../services/api/Connect';

/** Export request types */
export * from './types';

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function typeClient<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('type/client/list', data, options);
    case 'get':
      return id ? api.get(`type/client/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('type/client/set', data, options);
    case 'del':
      return id ? api.get(`type/client/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function command<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('/command/list', data, options);
    case 'get':
      return id ? api.get(`/command/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('/command/set', data, options);
    case 'del':
      return id ? api.get(`/command/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function typeModule<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('type/module/list', data, options);
    case 'get':
      return id ? api.get(`type/module/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('type/module/set', data, options);
    case 'del':
      return id ? api.get(`type/module/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function typeResult<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('/type/result/list', data, options);
    case 'get':
      return id ? api.get(`/type/result/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('/type/result/set', data, options);
    case 'del':
      return id ? api.get(`/type/result/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function typeSensor<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('/type/sensor/list', data, options);
    case 'get':
      return id ? api.get(`/type/sensor/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('/type/sensor/set', data, options);
    case 'del':
      return id ? api.get(`/type/sensor/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function typeSensorVariable<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('/type/sensor/variable/list?order=order', data, options);
    case 'get':
      return id ? api.get(`/type/sensor/variable/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('/type/sensor/variable/set', data, options);
    case 'del':
      return id ? api.get(`/type/sensor/variable/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function variable<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('variable/list', data, options);
    case 'get':
      return id ? api.get(`variable/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('variable/set', data, options);
    case 'del':
      return id ? api.get(`variable/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function sensorParameterTypes<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('type/sensor/parameter/list', data, options);
    case 'get':
      return id ? api.get(`type/sensor/parameter/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('type/sensor/parameter/set', data, options);
    case 'del':
      return id ? api.get(`type/sensor/parameter/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function parameter<T = any>(action: string, id?: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'list':
      return api.post('param/list', data, options);
    case 'get':
      return id ? api.get(`param/get/${id}`, data, options) : undefined;
    case 'set':
      return api.post('param/set', data, options);
    case 'del':
      return id ? api.get(`param/del/${id}`, data, options) : undefined;
    default:
      return undefined;
  }
}

/**
 * Executes and endpoint operation based on params
 *
 * @param action action to perform on endpoint
 * @param id identifier if necessary
 * @param data request body to send
 * @param options request options to send
 * @returns the response if is success or error otherwise
 */
export function lov<T = any>(action: string, id: string, data: any = {}, options?: AxiosRequestConfig): Promise<T> | undefined {
  switch (action) {
    case 'statics':
      return api.get(`lov/statics/${id}`, data, options);
    default:
      return undefined;
  }
}
